var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThankDonation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 65,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 61 65)",
    fill: "#F1EDF7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.5,
    cy: 12.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 141.5 12.5)",
    fill: "#00FFFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166,
    cy: 81,
    rx: 7,
    ry: 7,
    transform: "rotate(90 166 81)",
    fill: "#EB3366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.143 116.284L140.935 109.493C143.721 106.706 145.286 102.927 145.286 98.9874V63.0459C145.286 59.6271 142.515 56.8555 139.096 56.8555C132.258 56.8555 126.715 62.3986 126.715 69.2364V87.048",
    stroke: "url(#paint0_linear_8392_42919)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.43 116.282V104.502C104.43 102.532 105.212 100.642 106.605 99.2492L117.43 88.4249C120.507 85.3479 125.496 85.3479 128.573 88.4249C131.649 91.5019 131.649 96.491 128.573 99.5679L123.001 105.139",
    stroke: "url(#paint1_linear_8392_42919)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8577 116.284L53.0664 109.493C50.2801 106.706 48.7148 102.927 48.7148 98.9874V63.0459C48.7148 59.6271 51.4864 56.8555 54.9053 56.8555C61.7431 56.8555 67.2863 62.3986 67.2863 69.2364V87.048",
    stroke: "url(#paint2_linear_8392_42919)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5717 116.286V104.506C89.5717 102.536 88.789 100.647 87.3959 99.2529L76.5717 88.4288C73.4947 85.3518 68.5058 85.3518 65.4288 88.4288C62.3518 91.5057 62.3518 96.4947 65.4288 99.5716L71.0003 105.143",
    stroke: "url(#paint3_linear_8392_42919)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8209 71.7662L75.2488 49.962C62.402 37.0562 81.1418 12.0698 98.8209 32.2829C116.5 12.1288 135.417 37.1152 122.393 49.962L98.8209 71.7662Z",
    fill: "url(#paint4_linear_8392_42919)",
    stroke: "url(#paint5_linear_8392_42919)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8392_42919",
    x1: 145.075,
    y1: 86.0826,
    x2: 111.678,
    y2: 89.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8392_42919",
    x1: 130.58,
    y1: 100.952,
    x2: 86.3413,
    y2: 114.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8392_42919",
    x1: 67.0752,
    y1: 86.0826,
    x2: 33.6785,
    y2: 89.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8392_42919",
    x1: 89.2711,
    y1: 100.956,
    x2: 45.0327,
    y2: 114.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8392_42919",
    x1: 126.081,
    y1: 47.831,
    x2: 38.6441,
    y2: 82.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8392_42919",
    x1: 126.081,
    y1: 47.831,
    x2: 38.6441,
    y2: 82.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankDonation);
export default __webpack_public_path__ + "static/media/thankDonation.dc3c0f11a80fb5292ea5fb6d4796a4bf.svg";
export { ForwardRef as ReactComponent };